const getEnv = (mark = 'hxjf', hostname = window.location.hostname) => {
  const tag = hostname.match(new RegExp(`.*(?=${mark})`))
  if (!tag) {
    return 'local'
  }
  return tag[0] ? tag[0].replace('-', '') : 'production'
}

const getBaseUrl = (env = 'sit', isOpenApi?: boolean) => {
  let url = ''
  if (getEnv() === 'local') {
    const query: {
      devProxy?: string
      [propName: string]: string | undefined
    } = {}
    // for (const key in new URLSearchParams(location.search.slice(1))) {
    //   query[key] = location.search.slice(1)[key]
    // }
    query.devProxy =
      location.search.slice(1).split('=')[1] ||
      location.hash.slice(1).split('=')[1]
    // const query = querystring.parse(location.search.slice(1));
    const devProxy = query.devProxy || `${env}-api`
    url = `${devProxy}${isOpenApi ? '/vue-openapi' : ''}`
  } else if (isOpenApi) {
    url = '/vue-openapi'
  } else {
    url = '/vue-api'
  }
  return url
}
const getLocationEnv = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const devProxy = urlParams.get('devProxy')
  if (devProxy) {
    return devProxy.split('-')[0].replace('/', '')
  }
  return ''
}

export { getEnv, getBaseUrl, getLocationEnv }
